import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import PlanStatusIcon from '../badges/PlanStatusIcon'
import PlanStatusBadge from '../badges/PlanStatusBadge'
import UrgentBadge from '../badges/UrgentBadge'
import TaskCountBadge from '../badges/TaskCountBadge'
import { resolveItemTaskIds } from '../helpers'
import DescriptionTooltip from './DescriptionTooltip'

function PlanItemRow ({ item, isSelected, statusStyleOverrides, onSelect }) {
  const handleClick = () => onSelect(item.id)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onSelect(item.id)
    }
  }

  const taskCount = resolveItemTaskIds(item)?.length ?? 0

  return (
    <div
      role='button'
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={clsx('__detail flex flex-row items-center w-full m-0 font-light', { __selected: isSelected })}
    >
      <div className='__status flex items-center'>
        <PlanStatusIcon status={item.status} size={20} statusStyleOverrides={statusStyleOverrides} />
      </div>
      <div className='flex flex-col flex-1 py-2 gap-sm items-start' style={{ minWidth: 0 }}>
        <div className='flex flex-col'>
          <div className='flex items-center gap-xs'>
            <span className='__name-main'>{item.name}</span>
            <DescriptionTooltip content={item.information} />
          </div>
          {item.description ? (
            <span className='__subtitle font-size-xs font-light'>{item.description}</span>
          ) : null}
        </div>
        <div className='flex flex-wrap gap-2'>
          <PlanStatusBadge status={item.status} statusStyleOverrides={statusStyleOverrides} />
          {item.metadata?.needsAttention ? <UrgentBadge reason={item.metadata.needsAttentionReason} /> : null}
        </div>
      </div>
      <TaskCountBadge count={taskCount} />
    </div>
  )
}

PlanItemRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    status: PropTypes.string,
    description: PropTypes.string,
    information: PropTypes.string,
    metadata: PropTypes.object,
    taskIds: PropTypes.array,
    tasks: PropTypes.array
  }).isRequired,
  isSelected: PropTypes.bool,
  statusStyleOverrides: PropTypes.object,
  onSelect: PropTypes.func.isRequired
}

export default PlanItemRow
